var map = {
	"./boxed-theme.jpg": "f402",
	"./classic-theme.jpg": "efd5",
	"./fiber-guides.jpg": "6c7c",
	"./fiber-home.jpg": "120c",
	"./gallery-theme.jpg": "3650",
	"./modern-theme.jpg": "c96d",
	"./sample-endpoints.jpg": "cd6e",
	"./sample-home.jpg": "760f",
	"./standard-theme.jpg": "2db2",
	"./taptab-endpoints.jpg": "89f8",
	"./taptab-home.jpg": "bfab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f47c";